import classNames from "classnames";
import type { FC } from "react";
import styles from "./styles.module.scss";

export type ViewProps = {
  id: string;
  label: string;
  value: string;
  about?: string;
  subLabel?: string;
  subValue?: string;
  valueDarkColor?: boolean;
};

export const View: FC<ViewProps> = ({
  label,
  value,
  subLabel,
  subValue,
  about,
  valueDarkColor,
}) => {
  return (
    <div className={styles.view}>
      <div className={styles["label-column"]}>
        <p className={styles.label}>{label}</p>
        <p className={styles["sub-label"]}>{subLabel}</p>
      </div>
      <div className={styles["value-column"]}>
        <p className={classNames(styles.value, { [styles["value-dark"]]: valueDarkColor })}>
          {value}
        </p>
        <p className={styles["sub-value"]}>{subValue}</p>
        <p className={styles.about}>{about}</p>
      </div>
    </div>
  );
};
